import { useRef, useCallback } from 'react';

export const useVideoSlider = () => {
  const sliderRef = useRef<HTMLDivElement>(null);

  const getSlideWidth = useCallback(() => {
    const slider = sliderRef.current;
    if (!slider) return 0;
    const firstCard = slider.querySelector('.video-card') as HTMLElement;
    if (!firstCard) return 0;
    const style = window.getComputedStyle(firstCard);
    return (
      firstCard.offsetWidth +
      parseFloat(style.marginLeft) +
      parseFloat(style.marginRight)
    );
  }, []);

  const scrollPrev = useCallback(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    const slideWidth = getSlideWidth();
    slider.scrollTo({
      left: slider.scrollLeft - slideWidth,
      behavior: 'smooth',
    });
  }, [getSlideWidth]);

  const scrollNext = useCallback(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    const slideWidth = getSlideWidth();
    slider.scrollTo({
      left: slider.scrollLeft + slideWidth,
      behavior: 'smooth',
    });
  }, [getSlideWidth]);

  return {
    sliderRef,
    scrollPrev,
    scrollNext,
  };
};
